<template>
  <section
    id="cover"
    class="te-bg-wordpress-image relative flex h-[500px] flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faWordpress"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      WordPressコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      WordPressをカスタマイズしてオリジナルサイトを構築しよう
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        WordPressを勉強・学習して短期間でオリジナ
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >ルサイトを構築できるようになる講座。スクールではあなたのワードプレスオリジナルサイトをインターネット上に公開することがゴールです。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでオリジナルサイトの開発までサポート。レンタルサーバー無料の特典あり。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faWordpress } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faWordpress,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-wordpress-image {
  background-image: linear-gradient(
    to top,
    rgba(16, 75, 102, .75),
    rgba(30, 140, 190, .75)
  ),
    url('~/assets/images/Te/TeCourse/Wordpress/Cover/wordpress.jpg');
}
</style>
